var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Category icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8333 6.41667C12.8333 8.44171 11.1917 10.0833 9.16667 10.0833C7.14162 10.0833 5.5 8.44171 5.5 6.41667C5.5 4.39162 7.14162 2.75 9.16667 2.75C11.1917 2.75 12.8333 4.39162 12.8333 6.41667Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F5A524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.83333 19.25V17.4167C1.83333 16.4442 2.21964 15.5116 2.90728 14.8239C3.59491 14.1363 4.52754 13.75 5.5 13.75H10.0833",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F5A524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.7917 16.5C18.7917 17.7657 17.7657 18.7917 16.5 18.7917C15.2343 18.7917 14.2083 17.7657 14.2083 16.5C14.2083 15.2343 15.2343 14.2083 16.5 14.2083C17.7657 14.2083 18.7917 15.2343 18.7917 16.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F5A524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.5 12.8333V14.2083",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F5A524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.5 18.7917V20.1667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F5A524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.7083 14.6667L18.5167 15.3542",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F5A524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.4833 17.6458L13.2917 18.3333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F5A524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.7083 18.3333L18.5167 17.6458",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F5A524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M14.4833 15.3542L13.2917 14.6667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F5A524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatReferral);
export default __webpack_public_path__ + "static/media/cat_referral.0fef184de2c0227c9d8b5bc47b7f087f.svg";
export { ForwardRef as ReactComponent };